import { render, staticRenderFns } from "./CapacitorDielectricViz.vue?vue&type=template&id=a883dd1a&scoped=true"
import script from "./CapacitorDielectricViz.vue?vue&type=script&lang=js"
export * from "./CapacitorDielectricViz.vue?vue&type=script&lang=js"
import style0 from "./CapacitorDielectricViz.vue?vue&type=style&index=0&id=a883dd1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a883dd1a",
  null
  
)

export default component.exports